<button pButton [label]="'kam.moduleManagement.addModule' | translate" icon="pi pi-cog" class="p-button-primary"
  (click)="openDialog()">
</button>

<p-dialog 
  [header]="'kam.moduleManagement.addModule' | translate"   
  [closable]="false"
  [(visible)]="isVisible" [modal]="true"
  [style]="{width: '40rem'}" [draggable]="false" [resizable]="false" (onHide)="resetForm()">

  <form [formGroup]="moduleForm" class="grid md:grid-cols-4 grid-cols-2 gap-4 text-left">
     <div class="col-span-1">
      <label for="isPublic">
        {{ 'kam.moduleManagement.isPublic' | translate }}
      </label>
      <br>
      <p-toggleswitch formControlName="isPublic" onLabel="Yes" offLabel="No" class="w-36 mt-2">
        <ng-template #handle let-checked="checked">
          <i [ngClass]="['!text-xs', 'pi', checked ? 'pi-check' : 'pi-times']"></i>
        </ng-template>
      </p-toggleswitch>
    </div>

    <div class="md:col-span-3 col-span-1">
      <label for="isDefault">
        {{ 'kam.moduleManagement.isDefault' | translate }}
      </label>
      <br>
      <p-toggleswitch formControlName="isDefault" onLabel="Yes" offLabel="No" class="w-36 mt-2">
        <ng-template #handle let-checked="checked">
          <i [ngClass]="['!text-xs', 'pi', checked ? 'pi-check' : 'pi-times']"></i>
        </ng-template>
      </p-toggleswitch>
    </div>
    <div class="col-span-2">
      <label for="name">
        {{ 'kam.moduleManagement.name' | translate }}
      </label>
      <input id="name" pInputText type="text" formControlName="name"
        [placeholder]="'kam.moduleManagement.newModulePlaceholder' | translate" class="w-full mt-2" />

      @if (f['name'].invalid && (f['name'].dirty || f['name'].touched)) {
        <p class="text-red-500 text-sm mt-1">
          {{ 'kam.moduleManagement.requiredName' | translate }}
        </p>
      }
    </div>

    <div class="col-span-2">
      <label for="abbreviation">
        {{ 'kam.moduleManagement.abbreviation' | translate }}
      </label>
      <input id="abbreviation" pInputText type="text" formControlName="abbreviation"
        [placeholder]="'kam.moduleManagement.abbreviationPlaceholder' | translate" class="w-full mt-2 uppercase" />

      @if (f['abbreviation'].invalid && (f['abbreviation'].dirty || f['abbreviation'].touched)) {
        <p class="text-red-500 text-sm mt-1">
          {{ 'kam.moduleManagement.requiredAbbreviation' | translate }}
        </p>
      }
    </div>

    

    <div class="md:col-span-4 col-span-2">
      <label class="font-medium">
        {{ 'kam.moduleManagement.claims' | translate }}
      </label>
      <p-multiSelect #claimsMultiSelect [options]="claims()" formControlName="claims"
        placeholder="{{ 'kam.moduleManagement.selectClaims' | translate }}" appendTo="body" optionLabel="translatedName"
        [panelStyle]="{ width: '100%' }"
        [showToggleAll]="true" [showHeader]="false"
        class="w-full mt-2">
        <ng-template #header>
          <div class="flex flex-col gap-2 pt-2 pb-3 px-4 border-b border-[var(--border-color)]">
            <p-iconfield iconPosition="left" class="w-full">
              <p-inputicon>
                <i class="pi pi-search"></i>
              </p-inputicon>
              <input pInputText type="text" [placeholder]="'searchPlaceholder' | translate"
                (input)="claimsMultiSelect.onFilterInputChange($event)" class="w-full" />
            </p-iconfield>
            <div class="flex items-center justify-between gap-2">
              <div class="flex items-center gap-2">
                <p-checkbox [binary]="true" [ngModel]="claimsMultiSelect.allSelected()"
                  (onChange)="claimsMultiSelect.onToggleAll($event)" />
                <span>{{ "kam.moduleManagement.selectAll" | translate }}</span>
              </div>
              <span class="claim-selected-count">
                {{ "kam.moduleManagement.selectedCount" | translate: { count: f['claims'].value?.length || 0 } }}
              </span>
            </div>
          </div>
        </ng-template>
      </p-multiSelect>

      @if (f['claims'].invalid && (f['claims'].dirty || f['claims'].touched)) {
        <p class="text-red-500 text-sm mt-1">
          {{ 'kam.moduleManagement.requiredClaim' | translate }}
        </p>
      }
    </div>
  </form>

  <ng-template #footer>
    <button pButton [label]="'closeButton' | translate" class="p-button-secondary" (click)="isVisible=false">
    </button>
    <button pButton [label]="'kam.moduleManagement.addModule' | translate" class="p-button-primary" (click)="onSubmit()"
      [loading]="isBusy()" [disabled]="moduleForm.invalid">
    </button>
  </ng-template>
</p-dialog>
